export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=708c8ceb91371f5a1a9d99a645e09fb0ed6bd5d426&name=pushAdClickData!'